import React, {useState, useEffect} from 'react';
import { Link } from "react-router-dom";
import './ErrorComponent.css'

function ErrorComponent() { 
  useEffect(() => {
     
  }, []);

  return (
    <div className='error-component'>
      <h2>Oops!! Something went wrong.</h2>
      <Link to={`/`} className='home-button'>Return to Home page</Link>
    </div>
  )
};

export default ErrorComponent;